import { Paper, Stack, Title } from "@mantine/core";

import { WordsDiff } from "@/components/WordsDiff";

export const AmendmentCardDetails = ({
  currentVersion,
  previousVersion,
  title,
  showRemoved,
}: {
  currentVersion?: string;
  previousVersion?: string;
  title: string;
  showRemoved?: boolean;
}) => {
  return (
    <Paper p="md" withBorder>
      <Stack>
        <Title mb="lg" order={4} c="gray.6">
          {title}
        </Title>
        <WordsDiff current={currentVersion} showRemoved={showRemoved} previous={previousVersion} />
      </Stack>
    </Paper>
  );
};
